// Entry point for the build script in your package.json
document.body.classList.remove("no-js");
